import { env } from '../env/env';
// Default is to use the Gateway URL.
// Certain cases like Mocking, we want to hit the Public API directly.
const C2FO_API_GATEWAY = env.getString('GATEWAY_URL');
const PUBLIC_API_URL = env.getString('PUBLIC_API_URL');
let url;
if (PUBLIC_API_URL) {
    url = `${PUBLIC_API_URL}/graphql`;
}
else if (C2FO_API_GATEWAY) {
    url = `${C2FO_API_GATEWAY}/api/public/graphql`;
}
else {
    url = 'http://localhost:9999/graphql';
}
export const publicApiConfig = {
    PUBLIC_API_URL: url,
};
//# sourceMappingURL=publicApiConfig.js.map